import { ActionTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';

const constructionActions = <ActionTree<IPropertyEditState, any>>{
}

export default constructionActions;